import React, { useState } from 'react';
import { 
  Box, 
  Paper, 
  Typography, 
  TextField, 
  Button, 
  Grid, 
  Card, 
  CardMedia, 
  CardContent, 
  Alert, 
  CircularProgress 
} from '@mui/material';
import { api } from '../../context/AuthContext';

const QRCodeGenerator = () => {
  const [quantity, setQuantity] = useState(10);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [qrCodes, setQrCodes] = useState([]);

  const handleGenerate = async () => {
    if (quantity < 1 || quantity > 100) {
      setError('Please enter a quantity between 1 and 100');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await api.post('/api/qrcodes/generate', { quantity });
      setQrCodes(response.data.codes);
      setSuccess(`Successfully generated ${response.data.codes.length} QR codes`);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to generate QR codes');
      console.error('Error generating QR codes:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          QR Code Generator
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

        <Box sx={{ mb: 4 }}>
          <TextField
            type="number"
            label="Quantity"
            value={quantity}
            onChange={(e) => setQuantity(parseInt(e.target.value) || 0)}
            InputProps={{ inputProps: { min: 1, max: 100 } }}
            sx={{ mr: 2 }}
          />
          <Button 
            variant="contained" 
            onClick={handleGenerate} 
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Generate QR Codes'}
          </Button>
        </Box>

        {qrCodes.length > 0 && (
          <>
            <Typography variant="h5" gutterBottom>
              Generated QR Codes
            </Typography>
            <Grid container spacing={2}>
              {qrCodes.map((code) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={code.code}>
                  <Card>
                    <CardMedia
                      component="img"
                      height="200"
                      image={`${process.env.REACT_APP_API_URL || ''}${code.imageUrl}`}
                      alt={`QR Code: ${code.code}`}
                      sx={{ objectFit: 'contain', p: 2 }}
                    />
                    <CardContent>
                      <Typography variant="body2" color="text.secondary">
                        Code: {code.code}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default QRCodeGenerator;